import React from 'react';
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

export default class WebChanges extends React.Component {

    state = {
        src: null,
        crop: {
            unit: 'px'
        }
    }

    onCropChange = (crop) => {
        this.setState({ crop });
    };

    render() {

        const { crop, src } = this.state;

        return (
            <div>
                {/* Add/Edit/View/Delete Already Setup Monitoring */}



                {src && (
                    <ReactCrop
                        src={src}
                        crop={crop}
                        //onImageLoaded={this.onImageLoaded}
                        onChange={this.onCropChange}
                    />
                )}
            </div>
        );
    }
}